import React from 'react'

const Icons = ({ toolName, className, onClick, options = {} }) => {
  const Icon = require(`./${toolName}`).default
  const props = {
    ...(className && { className }),
    ...(onClick && { onClick }),
    options,
  }
  return <Icon {...props} />
}

export default Icons
